/**
 * Constant to check if the Telia ID script exists.
 * @type {boolean}
 */
const TELIA_ID_SCRIPT_EXISTS = typeof TELIA_ID_SCRIPT !== "undefined";
/**
 * Constant to determine if the environment is production.
 * @type {boolean}
 */
const TELIA_PRODUCTION = TELIA_ID_SCRIPT_EXISTS
  ? TELIA_ID_SCRIPT.production
  : true;
console.debug("Telia production: " + TELIA_PRODUCTION);

// URLS.
const teliaUrl = "https://tunnistus.telia.fi/uas/oauth2/authorization";
const teliaUrlDev = "https://tunnistus-pp.telia.fi/uas/oauth2/authorization";
const teliaRedirect = "https://www.puhti.fi/wp-json/puhti/v1/auth";
const teliaRedirectDev = "https://www.puhti.fi/wp-json/puhti/v1/auth";
const acrValue = "http://ftn.ficora.fi/2017/loa2";
const acrValueDev = "http://ftn.ficora.fi/2017/loatest2";

// Client keys.
const teliaClientId = "1215d462-3888-43f9-b238-81b75006e220";
const teliaClientIdDev = "df7fcf42-24e8-4a69-9c16-6566863ec373";

/**
 * Setup Telia Identification.
 */
const setup = () => {
  initButton();
  handleMultiStepEvents();
};

/**
 * Only use Telia Identification if identification step is present in checkout.
 */
const shouldAuthBeUsed = () => {
  const identificationStep = document.querySelector(
    '[data-step-title="identification"]',
  );
  if (identificationStep) {
    setup();
  }
};

/**
 * Add event listener to start identification button.
 */
const initButton = () => {
  const button = document.getElementById("start-telia-tunnistus");

  if (button) {
    button.addEventListener("click", (event) => {
      startAuthentication();
    });
  }
};

/**
 * Handle multistep checkout events and styles.
 */
const handleMultiStepEvents = () => {
  const next = document.getElementById("wpmc-next");
  const identificationStep = document.querySelector(
    '[data-step-title="identification"]',
  );
  billingStepFunction(next);
  // If Telia Authentication cookie exists add visited class to identification step.
  if (checkThatCookieExists("telia_auth=")) {
    identificationStep.classList.add("visited");
  }
  jQuery(".woocommerce-checkout").on("wpmc_after_switching_tab", function () {
    billingStepFunction(next);
  });
};

/**
 * Get the relevant url automatically based on TELIA_PRODUCTION constant.
 * @returns {string} The relevant url.
 */
const getUrl = () => {
  return TELIA_PRODUCTION ? teliaUrl : teliaUrlDev;
};

/**
 * Get the relevant client id based on TELIA_PRODUCTION constant.
 * @returns {string} The relevant client id.
 */
const getClientID = () => {
  return TELIA_PRODUCTION ? teliaClientId : teliaClientIdDev;
};

/**
 * Get the relevant redirect url based on TELIA_PRODUCTION constant.
 * @returns {string}
 */
const getRedirectUrl = () => {
  return TELIA_PRODUCTION ? teliaRedirect : teliaRedirectDev;
};

/**
 * Get the relevant ACR Value based on TELIA_PRODUCTION constant.
 * @returns {string}
 */
const getAcrValue = () => {
  return TELIA_PRODUCTION ? acrValue : acrValueDev;
};

const getHtmlLang = () => {
  return document.documentElement.lang;
};

/**
 * Start the authentication process on start button click.
 */
const startAuthentication = () => {
  const stateData = {
    redirect: window.location.hostname,
    lang: getHtmlLang(),
  };
  const base64data = btoa(JSON.stringify(stateData));
  const state = encodeURIComponent(base64data);
  document.location =
    getUrl() +
    "?scope=openid&response_type=code&client_id=" +
    getClientID() +
    "&redirect_uri=" +
    getRedirectUrl() +
    "&state=" +
    state +
    "&acr_values=" +
    getAcrValue() +
    "&ui_locales=" +
    getHtmlLang();
};

/**
 * Helper function to check if a cookie exists.
 * @param cookieName {string} The cookie name to check for.
 * @returns {boolean}
 */
const checkThatCookieExists = (cookieName) => {
  return document.cookie
    .split(";")
    .some((item) => item.trim().startsWith(cookieName));
};

/**
 * Only allow going to billing step if Telia Identification cookie has been set.
 * @param nextButton
 */
const billingStepFunction = (nextButton) => {
  const billingStep = document.querySelector('[data-step-title="billing"]');
  if (window.location.hash === "#billing") {
    if (!checkThatCookieExists("telia_auth=")) {
      window.location = window.location.hash = "#identification";
    }
  }
  if (window.location.hash === "#identification") {
    if (!checkThatCookieExists("telia_auth=")) {
      nextButton.style.setProperty("display", "none", "important");
      billingStep.classList.remove("visited");
    }
  }
};

window.addEventListener("load", shouldAuthBeUsed);
